// dashboard-agent-ia/src/pages/PaymentSuccess.js
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

const PLAN_NAMES = { starter: 'Starter', pro: 'Pro', premium: 'Premium' }
const PLAN_COLORS = { starter: '#3b82f6', pro: '#8b5cf6', premium: '#f59e0b' }

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const plan = searchParams.get('plan')
  const businessId = searchParams.get('businessId')
  const [status, setStatus] = useState('loading')

  useEffect(() => {
    if (!plan || !businessId) { setStatus('error'); return }

    // Si on est dans un popup PayTech, fermer et recharger la page parent
    if (window.opener) {
      setStatus('success')
      setTimeout(() => {
        window.opener.location.reload()
        window.close()
      }, 2000)
      return
    }

    // Sinon vérifier le statut normalement
    setTimeout(async () => {
      try {
        const res = await axios.get(`${API_URL}/api/payments/status/${businessId}`)
        if (res.data.isActive) {
          setStatus('success')
          setTimeout(() => navigate('/business-dashboard'), 4000)
        } else {
          setStatus('pending')
        }
      } catch (e) { setStatus('pending') }
    }, 2000)
  }, [plan, businessId, navigate])

  const color = PLAN_COLORS[plan] || '#3b82f6'

  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 24, padding: 'clamp(30px,5vw,60px) clamp(20px,4vw,48px)', maxWidth: 480, width: '90%', textAlign: 'center' }}>
        {status === 'loading' && (
          <>
            <div style={{ width: 60, height: 60, border: `3px solid ${color}`, borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 24px' }}/>
            <h2 style={{ color: 'white', fontSize: 24, fontWeight: 700 }}>Vérification du paiement...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ fontSize: 72, marginBottom: 24 }}>🎉</div>
            <h2 style={{ color: 'white', fontSize: 32, fontWeight: 800, marginBottom: 12 }}>Paiement confirmé !</h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 16, marginBottom: 32 }}>
              Votre abonnement <strong style={{ color }}>{PLAN_NAMES[plan]}</strong> est maintenant actif. Redirection dans 5 secondes...
            </p>
            <Link to={`/business/${businessId}`} style={{ background: color, color: 'white', padding: '14px 32px', borderRadius: 12, textDecoration: 'none', fontWeight: 700, fontSize: 16 }}>
              Accéder au dashboard →
            </Link>
          </>
        )}
        {status === 'pending' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 24 }}>⏳</div>
            <h2 style={{ color: 'white', fontSize: 28, fontWeight: 800, marginBottom: 12 }}>Paiement en cours de validation</h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, marginBottom: 32 }}>
              Votre paiement est en cours de traitement. Votre compte sera activé automatiquement dans quelques minutes.
            </p>
            <Link to={`/business/${businessId}`} style={{ background: '#3b82f6', color: 'white', padding: '14px 32px', borderRadius: 12, textDecoration: 'none', fontWeight: 700 }}>
              Aller au dashboard
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 24 }}>❌</div>
            <h2 style={{ color: 'white', fontSize: 28, fontWeight: 800, marginBottom: 12 }}>Erreur</h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: 24 }}>Lien invalide. Contactez-nous.</p>
            <a href="https://wa.me/221776480068" style={{ background: '#25d366', color: 'white', padding: '14px 28px', borderRadius: 12, textDecoration: 'none', fontWeight: 700 }}>
              Contacter le support
            </a>
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
